(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-amethyst-geode"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-geo-video-trigger]');
    if (trigger) {
      var modal = document.querySelector('[data-geo-video-modal]');
      var player = modal.querySelector('[data-geo-video-player]');
      player.src = trigger.getAttribute('data-video-url');
      modal.hidden = false;
      player.play();
      return;
    }
    if (event.target.closest('[data-geo-video-close]')) {
      var modal = document.querySelector('[data-geo-video-modal]');
      var player = modal.querySelector('[data-geo-video-player]');
      player.pause();
      modal.hidden = true;
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-jellyfish-aquarium-lamp"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-jaq-video-trigger]');
    if (trigger) {
      var modal = document.querySelector('[data-jaq-video-modal]');
      var player = modal.querySelector('[data-jaq-video-player]');
      player.src = trigger.getAttribute('data-video-url');
      modal.hidden = false;
      player.play();
      return;
    }
    if (event.target.closest('[data-jaq-video-close]')) {
      var modal = document.querySelector('[data-jaq-video-modal]');
      var player = modal.querySelector('[data-jaq-video-player]');
      player.pause();
      modal.hidden = true;
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-olive-oil-sprayer"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-oos-video-trigger]');
    if (trigger) {
      var modal = document.querySelector('[data-oos-video-modal]');
      var player = modal.querySelector('[data-oos-video-player]');
      player.src = trigger.getAttribute('data-video-url');
      modal.hidden = false;
      player.play();
      return;
    }
    if (event.target.closest('[data-oos-video-close]')) {
      var modal = document.querySelector('[data-oos-video-modal]');
      var player = modal.querySelector('[data-oos-video-player]');
      player.pause();
      modal.hidden = true;
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-sunset-lamp"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-sun-video-trigger]');
    if (trigger) {
      var modal = document.querySelector('[data-sun-video-modal]');
      var player = modal.querySelector('[data-sun-video-player]');
      player.src = trigger.getAttribute('data-video-url');
      modal.hidden = false;
      player.play();
      return;
    }
    if (event.target.closest('[data-sun-video-close]')) {
      var modal = document.querySelector('[data-sun-video-modal]');
      var player = modal.querySelector('[data-sun-video-player]');
      player.pause();
      modal.hidden = true;
    }
  });

  } catch(e) { console.error(e); }
})();
})();
